<template>
  <div id="hcp-switch-modal" v-if="dialog">
    <mu-dialog />
    <div class="modal">
      <p class="title" v-text="isHcpView ? 'Go to patient view' : 'Go to HCP view'"></p>
      <p v-if="isHcpView">You're about to switch to the patient view of the website</p>
      <p v-if="!isHcpView">You're about to switch to the HCP view of the website</p>
      <div class="actions" align="right">
        <mu-flat-button
          class="action close"
          label="Close"
          color="#0179d5"
          @click="closeModal()"
        />
        <mu-flat-button
          class="action continue"
          label="Continue"
          color="#0179d5"
          @click="doSwitch()"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import HcpMixin from '../../mixins/HCPMixin';
  export default {
    mixins: [
      HcpMixin
    ],
    watch: {
      "open": function() {
        let self = this;
        self.dialog = self.open;
      }
    },
    name: 'hcp-switch-modal',
    props: {
      open: {
        type: Boolean,
        required: true,
        default: false,
      }
    },
    data() {
      return {
        dialog: false
      }
    },
    methods: {
      doSwitch() {
        let self = this;
        self.closeModal();
        self.switchProgram();
      },
      closeModal() {
        let self = this;
        self.$emit("close", false);
      },
    },
    mounted() {
      let self = this;
      self.dialog = self.open;
    }
  }

</script>

<style lang="less">
  #hcp-switch-modal {
    width: 100%;
    height: 100%;
    background-color: fade(#000, 12%);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    .modal {
      max-width: 280px;
      width: 100%;
      padding: 24px;
      padding-bottom: 16px;
      border-radius: 4px;
      line-height: 1.5;
      letter-spacing: 0.2px;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.6);
      background-color: #FFF;
      box-shadow: rgba(0, 0, 0, 0.298039) 0 19px 60px, rgba(0, 0, 0, 0.219608) 0 15px 20px;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      position: absolute;
      top: 50%;
      left: 50%;
      .title {
        margin: 0;
        font-size: 20px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0.3px;
        color: rgba(0, 0, 0, 0.87);
      }
      .actions {
        .action {
          font-weight: 500;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// SwitchProgram.vue?4cf265e8